import { render, staticRenderFns } from "./GAuthTextForm.vue?vue&type=template&id=5d06e789&"
import script from "./GAuthTextForm.vue?vue&type=script&lang=ts&"
export * from "./GAuthTextForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports